import { render, staticRenderFns } from "./tmpCheck.vue?vue&type=template&id=4956bfc2&scoped=true&"
import script from "./tmpCheck.vue?vue&type=script&lang=js&"
export * from "./tmpCheck.vue?vue&type=script&lang=js&"
import style0 from "./tmpCheck.vue?vue&type=style&index=0&id=4956bfc2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4956bfc2",
  null
  
)

export default component.exports